import bloom1 from './stocks/bloomberg/bloom1.png';
import bloom2 from './stocks/bloomberg/bloom2.png';
import bloom3 from './stocks/bloomberg/bloom3.png';
import bloom4 from './stocks/bloomberg/bloom4.png';
import bloom5 from './stocks/bloomberg/bloom5.png';
import bloom6 from './stocks/bloomberg/bloom6.png';
import bloombergIcon from './stocks/bloomberg/bloomberg.png';
import compound1 from './stocks/IRA/compound1.png';
import compound2 from './stocks/IRA/compound2.png';
import warrenLogo from './stocks/warren/warrenlogo.png';

import richest from './bookclub/richest.jpg';

import alchemist from './bookclub/alchemist.jpg';
import aprender from './bookclub/aprender.jpg';
import aristotle from './bookclub/aristotlre.jpg';
import benfranklin from './bookclub/benfranklin.jpg';
import davidcant from './bookclub/davidcant.jpg';
import howtowinfriends from './bookclub/howtowinfriends.jpg';
import johnd from './bookclub/johnd.jpeg';
import letmypeople from './bookclub/letmypeaople.jpeg';
import loscuatro from './bookclub/loscuatro.jpg';
import markets from './bookclub/markets.jpg';
import naturalcapital from './bookclub/naturalcapital.jpg';
import neverfinished from './bookclub/neverfinished.jpg';
import platorepublic from './bookclub/platorepublic.jpg';
import poorcharlie from './bookclub/poorcharlie.jpg';
import psycology from './bookclub/psycology.jpg';
import samwalton from './bookclub/samwalton.jpg';
import suswhateverone from './bookclub/suswhateveryone.jpg';
import systems from './bookclub/systems.jpg';
import thealchemy from './bookclub/thealchemy.jpg';
import whatthedog from './bookclub/whatthedog.jpg';
 
export const Images = {
  warrenLogo,
  bloombergIcon,
  compound1,
  compound2,
  bloom1,
  bloom2,
  bloom3,
  bloom4,
  bloom5,
  bloom6,
  alchemist,
  aprender,
  aristotle,
  benfranklin,
  davidcant,
  howtowinfriends,
  johnd,
  letmypeople,
  loscuatro,
  markets,
  naturalcapital,
  neverfinished,
  platorepublic,
  poorcharlie,
  psycology,
  samwalton,
  suswhateverone,
  systems,
  thealchemy,
  whatthedog,
  richest,
} as const;